export default __webpack_public_path__ + "static/media/2.2fd11716.png";